import homeIcon from '@iconify/icons-ant-design/home-outline';
import { Icon } from '@iconify/react';
import RankingNo1Icon from '@/../img/ranking1.svg';
import RankingNo2Icon from '@/../img/ranking2.svg';
import RankingNo3Icon from '@/../img/ranking3.svg';
import RankingNo4Icon from '@/../img/ranking4.svg';
import RankingNo5Icon from '@/../img/ranking5.svg';
import React from 'react';
import { Tooltip, Whisper } from 'rsuite';
import styled from 'styled-components';
import * as ColorBar from './horizontal-color-bar-styles';

export const AccountsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  width: 100%;
  margin-top: 7px;
`;

const AccountRow = styled.div`
  height: 22px;
`;

export const Account = styled(AccountRow)`
  width: 100%;
  height: ${(props) => (props.isOwner ? '14px' : '22px')};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const TextWrapper = styled(AccountRow)`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
`;

const NameText = styled(TextWrapper)`
  display: block;
  max-width: 203px;
  color: rgba(0, 0, 0, 0.85);

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  margin-left: 10px;
`;

const rankingIcons = {
  1: RankingNo1Icon,
  2: RankingNo2Icon,
  3: RankingNo3Icon,
  4: RankingNo4Icon,
  5: RankingNo5Icon,
};

const RankingIconSizer = styled(AccountRow)`
  width: 17px;
  padding: 0;
  margin: 0;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const RankingAccountNameWrapper = styled(AccountRow)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const AccountName = ({ name }) => (
  <Whisper placement="top" trigger="hover" speaker={<Tooltip>{name}</Tooltip>}>
    <NameText>{name}</NameText>
  </Whisper>
);

export const RankingAccountName = ({ name, ranking, isOwner }) => {
  const RankingIcon = rankingIcons[ranking];
  return (
    <RankingAccountNameWrapper>
      {!isOwner && (
        <RankingIconSizer>
          <RankingIcon />
        </RankingIconSizer>
      )}
      <AccountName name={name} />
    </RankingAccountNameWrapper>
  );
};

const AccountStatsWrapper = styled(AccountRow)`
  display: flex;
  justify-content: flex-end;
`;

const RevenueTextWrapper = styled(TextWrapper)`
  color: rgba(0, 0, 0, 0.85);
`;

const IconSizer = styled(AccountRow)`
  width: 10px;
  display: flex;
  align-items: center;
  margin-right: 2px;
`;

const Separator = styled(AccountRow)`
  ::before {
    content: '|';
    color: rgba(0, 0, 0, 0.1);
    font-size: 12px;
    margin-left: 4px;
    margin-right: 4px;
  }
`;

const StyledBarWrapper = styled(ColorBar.BarWrapper)`
  margin-top: 10px;
  box-shadow: unset;

  div {
    box-shadow: unset;

    :first-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
`;

const DisplayNone = styled.div`
  display: none;
`;

const StyledBarItem = styled(ColorBar.Item)`
  height: 6px;
`;

const colorByPosition = ['#37A3BC', '#bae637', '#ffc53d', '#36cfc9', '#ff7875'];

const StyledEmptyBarItem = styled(ColorBar.Item)`
  height: 4px;
  align-self: center;
  background-color: #eaedf4;
`;

export function HorizontalMeter({ isOwner, score, maxScore, position }) {
  if (!isOwner) return <DisplayNone />;
  return (
    <StyledBarWrapper isOwner={isOwner}>
      <StyledBarItem color={colorByPosition[position]} value={score} />
      <StyledEmptyBarItem value={maxScore - score} />
    </StyledBarWrapper>
  );
}

export const AccountStats = ({ revenue, propertyCount }) => (
  <AccountStatsWrapper>
    <IconSizer>
      <Icon icon={homeIcon} width="10px" />
    </IconSizer>
    <TextWrapper>{propertyCount}</TextWrapper>
    <Separator />
    <RevenueTextWrapper>{revenue}</RevenueTextWrapper>
  </AccountStatsWrapper>
);
